<template>
	<Card :title="rotation.college.acronym" :subtitle="rotation.college.name">
		<template #badges>
			<Badge :color="badgeColor" active>{{ trans(`rotations.status.${rotation.status}`) }}</Badge>
			<i v-if="rotation.online" class="fa-solid fa-video text-gray-400"/>
		</template>
		<LabeledObject>
			<template #label>{{ trans('rotations.requests.registration') }}</template>
			<p>{{ rotation.registration_period }}</p>
		</LabeledObject>
		<LabeledObject>
			<template #label>{{ trans('rotations.requests.election') }}</template>
			<p>{{ rotation.election_period }}</p>
		</LabeledObject>
		<template #footer>
			<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.representatives.rotations.edit', rotation.id)">
				<i class="fa-solid fa-edit mr-2"/>
				{{ trans('general.edit') }}
			</Link>
		</template>
	</Card>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/UI/Cards/Card.vue'
import Badge from '@/Components/UI/Badges/Badge.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'
import SecondaryButton from '@/Components/UI/Buttons/SecondaryButton.vue'
import {computed, type ComputedRef, defineProps, ref, type Ref} from 'vue'
import {getRotationStatusColor} from '@/Helpers/Association/Representatives/rotation'

const props = defineProps<{
	rotation:Rotation,
}>()

const rotation:Ref<Rotation> = ref(props.rotation)

const badgeColor:ComputedRef<Color> = computed(():Color => {
	return getRotationStatusColor(rotation.value)
})
</script>